export const filterCustomSavedViews = ({ savedViews, doctorId }) => {
  return savedViews.filter(
    ({ isPrivate, creatorDoctorId, _deleted }) => !_deleted && (creatorDoctorId === doctorId || !isPrivate)
  )
}
